

























































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Typography from '@/components/common/elements/Typography.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';
import Table from '@/components/common/elements/Table.vue';
import { ItemActions } from '@/services/hexabase/types';
import hexabaseState from '@/store/hexabase';
import ConstructionModel from '@/models/constructionModel';
import Dialog from '@/components/common/modules/Dialog.vue';
import InputArea from '@/components/common/modules/InputArea.vue';

import FileClass from '@/models/lib/file';

@Component({
  components: { SingleText, Typography, Table, InputNoVModel, SelectNoVModel, Dialog, InputArea }
})
export default class DialogFormDownload extends Vue {
  private File = new FileClass();

  // ダイアログ開閉状態
  @Prop({ default: false })
  private dialog?: boolean;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // 確定原価（材料費） のアイテムデータ
  @Prop({ default: null })
  private fixedMaterialCost: any;
  // 確定原価（労務費） のアイテムデータ
  @Prop({ default: null })
  private fixedLaborCost: any;
  // 確定原価（その他） のアイテムデータ
  @Prop({ default: null })
  private fixedOtherCost: any;
  // 予定原価（材料費） のアイテムデータ
  @Prop({ default: null })
  private estimateMaterialCost: any;
  // 予定原価（労務費） のアイテムデータ
  @Prop({ default: null })
  private estimateLaborCost: any;
  // 予定原価（その他） のアイテムデータ
  @Prop({ default: null })
  private estimateOtherCost: any;
  // ラジオボタンの値
  private radioData?: any = 0;
  // コピー対象のアイテムデータ
  @Prop({ default: '' })
  private copyItemId: any;
  // 工事ドメインモデル
  private constructionModel = new ConstructionModel();
  // アイテムのアクション
  private itemActions: Array<ItemActions> = [];
  // 工事データストアID
  private mainDsId = hexabaseState.datastoreIds['工事'];
  // エラーメッセージ用
  private selectErrorMessages = '';
  /** APIに問い合わせ中に表示する「loading」フラグ */
  private isLoading = false;
  
  // 確定原価（材料費）
  private fixedMaterialCostItems: any = [];
  // 確定原価（労務費）
  private fixedLaborCostItems: any = [];
  // 確定原価（その他）
  private fixedOtherCostItems: any = [];
  // 予定原価（材料費）
  private estimateMaterialCostItems: any = [];
  // 予定原価（労務費）
  private estimateLaborCostItems: any = [];
  // 予定原価（その他）
  private estimateOtherCostItems: any = [];

  // 決算年度
  private fiscalYear: any = '';
  // 期
  private period: any = '';
  // 登録データ
  private registerItem: any = {};

  /**
   * ダイヤログ内の初期化を行う、親コンポーネントに押下したか否か通知する
   * @module confirmOperation
   * @return {AddDetailResponse} - 要素ステータス、押下判定
   */
  @Emit('confirmOperation')
  public confirmOperation(isAgree: boolean): { [k: string]: boolean } {
    return { dialog: false, isAgree: isAgree };
  }
  
  /**
   * 工事データのコピーを行う、親コンポーネントに押下したか否か通知する
   * @module copyButtonOperation
   * @return {void}
   */
  @Emit('copyButtonOperation')
  public copyButtonOperation(): void {
    this.copyConstructionData(this.copyItemId);
  }
  
  private inputOperation(Response: any){
    this.fiscalYear = Response.value;
  }

  /**
   * 該当のアクションをたたいて工事データをコピーする
   * @module copyConstructionData
   * @param {Object} item - アイテム情報
   */
  private async copyConstructionData(itemId: any) {
    this.isLoading = true;
    // 決算年度から期を設定する
    this.period = this.fiscalYear - 1959 > 0 ? this.fiscalYear - 1959 : null;

    // 1. 「採番管理」テーブルに対して、検索条件に登録する「期」を指定してレコード取得。
    const searchParams = {
      conditions: [
        {
          id: 'period',
          // search_value: [String(this.registData.item.period)]
          search_value: [String(this.period), String(this.period)]
        }
      ],
      sort_field_id: 'construction_no',
      sort_order: 'desc',
      per_page: 0,
      page: 1,
      use_display_id: true
    };
    const searchResult = await this.constructionModel.getItemList(hexabaseState.applicationId, hexabaseState.datastoreIds['採番管理'], searchParams);
    const periodConstructionNumber = searchResult.length > 0 ? Number(searchResult[0].construction_no) + 1 : 1;
    // getAutoNumberAPIで連番を取得しておく
    const autoNumber = await this.constructionModel.getAutoNumber(hexabaseState.applicationId, hexabaseState.datastoreIds['採番管理'], 'id', {});

    // 2. 「採番管理」テーブルにレコード登録。1で取得したAPI返り値に含まれる「工事番号」の値 + 1の数値で「工事番号」にセットする
    const numberingManagementItemParams = {
      period: this.period,
      construction_no: periodConstructionNumber
    };

    const itemDetails = await this.constructionModel.getItemDetails(hexabaseState.applicationId, this.mainDsId, itemId, 'map');
    const items: any = {};

    // ファイルコピー
    for (const key in itemDetails.field_values) {
      if (itemDetails.field_values[key].dataType === "file" && itemDetails.field_values[key].value) {
        items[itemDetails.field_values[key].field_id] = [];
        const fileIds: any = [];
        // 元データのfile_idを取得後、再アップロードを行いfile_idを再生成する
        for (let i = 0; i < itemDetails.field_values[key].value.length; i++) {
          const response = await this.constructionModel.getFileData(itemDetails.field_values[key].value[i].file_id, itemDetails.field_values[key].value[i].contentType);

          // PrototypeをblobからFileに変換
          const fileData: any = [];
          const file = this.read(new File([response], itemDetails.field_values[key].value[i].filename, {lastModified: 0}));
          fileData.push(file);

          // ファイルアップロードし、取得したfileIdを配列に格納
          const fileId = await this.File.uploadFiles(fileData);
          fileIds.push(fileId);
          items[itemDetails.field_values[key].field_id].push(fileId[0]);
        }
      } else {
        items[itemDetails.field_values[key].field_id] = itemDetails.field_values[key].value;
      }
    }

    // 工事番号を設定
    items['fiscal_year'] = this.fiscalYear;
    items['period'] = this.period;
    items['construction_no'] = periodConstructionNumber;
    delete items.id;

    // ExecuteBatchActionで登録する工事テーブルのアイテム再取得のための検索条件
    const registeredItemParams = {
      conditions: [
        {
          id: 'fiscal_year',
          search_value: [String(this.fiscalYear)],
          exact_match: true
        },
        {
          id: 'period',
          search_value: [String(this.period)],
          exact_match: true
        },
        {
          id: 'construction_no',
          search_value: [String(periodConstructionNumber)],
          exact_match: true
        }
      ],
      per_page: 0,
      page: 1,
      use_display_id: true
    };

    // 確定原価（材料費）
    const fixedMaterialCost: any = this.fixedMaterialCost;
    // 確定原価（労務費）
    const fixedLaborCost: any = this.fixedLaborCost;
    // 確定原価（消耗品・その他経費）
    const fixedOtherCost: any = this.fixedOtherCost;
    // 予定原価（材料費）
    const estimateMaterialCost: any = this.estimateMaterialCost;
    // 予定原価（労務費）
    const estimateLaborCost: any = this.estimateLaborCost;
    // 予定原価（消耗品・その他経費）
    const estimateOtherCost: any = this.estimateOtherCost;

    // ExecuteBatchActionで登録する工事データ用パラメータ
    let batchActionConstructionParams = {};

    if (this.radioData === 0) {
      const relatedData: any = {};
      if (fixedMaterialCost[0][0].props.value) {
        for (let i = 0; i < fixedMaterialCost.length; i++) {
          this.fixedMaterialCostItems[i] = {};
          this.fixedMaterialCostItems[i]['item'] = {};
          this.fixedMaterialCostItems[i]['operation'] = 1;
          this.fixedMaterialCostItems[i]['link_to_parent'] = true;
          this.createCostData(fixedMaterialCost[i], this.fixedMaterialCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_material_cost'] = this.fixedMaterialCostItems;
      }
      if (fixedLaborCost[0][0].props.value) {
        for (let i = 0; i < fixedLaborCost.length; i++){
          this.fixedLaborCostItems[i] = {};
          this.fixedLaborCostItems[i]['item'] = {};
          this.fixedLaborCostItems[i]['operation'] = 1;
          this.fixedLaborCostItems[i]['link_to_parent'] = true;
          this.createCostData(fixedLaborCost[i], this.fixedLaborCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_labor_cost'] = this.fixedLaborCostItems;
      }
      if (fixedOtherCost[0][0].props.value) {
        for (let i = 0; i < fixedOtherCost.length; i++){
          this.fixedOtherCostItems[i] = {};
          this.fixedOtherCostItems[i]['item'] = {};
          this.fixedOtherCostItems[i]['operation'] = 1;
          this.fixedOtherCostItems[i]['link_to_parent'] = true;
          this.createCostData(fixedOtherCost[i], this.fixedOtherCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_other_cost'] = this.fixedOtherCostItems;
      }

      // 登録する工事データ
      batchActionConstructionParams = {
        operation: 1, // new
        item: items,
        related_ds_items: relatedData
      };
    } else if (this.radioData === 1) {
      const relatedData: any = {};
      if (estimateMaterialCost[0][0].props.value) {
        for (let i = 0; i < estimateMaterialCost.length; i++){
          this.estimateMaterialCostItems[i] = {};
          this.estimateMaterialCostItems[i]['item'] = {};
          this.estimateMaterialCostItems[i]['operation'] = 1;
          this.estimateMaterialCostItems[i]['link_to_parent'] = true;
          this.createCostData(estimateMaterialCost[i], this.estimateMaterialCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_material_cost'] = this.estimateMaterialCostItems;
      }
      if (estimateLaborCost[0][0].props.value) {
        for (let i = 0; i < estimateLaborCost.length; i++){
          this.estimateLaborCostItems[i] = {};
          this.estimateLaborCostItems[i]['item'] = {};
          this.estimateLaborCostItems[i]['operation'] = 1;
          this.estimateLaborCostItems[i]['link_to_parent'] = true;
          this.createCostData(estimateLaborCost[i], this.estimateLaborCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_labor_cost'] = this.estimateLaborCostItems;
      }
      if (estimateOtherCost[0][0].props.value) {
        for (let i = 0; i < estimateOtherCost.length; i++){
          this.estimateOtherCostItems[i] = {};
          this.estimateOtherCostItems[i]['item'] = {};
          this.estimateOtherCostItems[i]['operation'] = 1;
          this.estimateOtherCostItems[i]['link_to_parent'] = true;
          this.createCostData(estimateOtherCost[i], this.estimateOtherCostItems[i]['item'], periodConstructionNumber);
        }
        relatedData['t_estimate_other_cost'] = this.estimateOtherCostItems;
      }

      // 登録する工事データ
      batchActionConstructionParams = {
        operation: 1, // new
        item: items,
        related_ds_items: relatedData
      };
    } else if (this.radioData === 2) {
      // 登録する工事データ
      batchActionConstructionParams = {
        operation: 1, // new
        item: items
      };
    }

    // 「採番管理」テーブルへのINSERTと、「工事」テーブルへのINSERTを1トランザクションで実行
    const batchActionPayload = {
      ensure_transaction: true,
      item_actions: {
        [hexabaseState.datastoreIds['採番管理']]: [
          {
            operation: 1, // new
            item: numberingManagementItemParams
          }
        ],
        [this.mainDsId]: [batchActionConstructionParams]
      }
    };
    const batchActionResponse = await this.constructionModel.executeBatchAction(
      hexabaseState.applicationId,
      batchActionPayload
    );

    // ExecuteBatchActionでは登録したアイテムの情報を返すことができないため、改めて取得
    const registeredItem = await this.constructionModel.getItemList(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['工事'],
      registeredItemParams
    );

    this.isLoading = false;
    this.confirmOperation(false);
    this.$router.push(`/construction/constructionedit/${registeredItem[0].i_id}`);
    this.$router.go(Number({ path: this.$router.currentRoute.path, force: true }));
  }

  /**
   * 原価の登録データ作成
   * @module createCostData
   * @param {Object} item - アイテム情報
   */

  private createCostData(fixedCost: any, fixedCostItems: any, constructionNum: any){
    for (let i = 0; i < fixedCost.length; i++) {
      if (fixedCost[i].display_id === 'quantity;unit_price;unit') {
        const displayIds = fixedCost[i].display_id.split(';');
        const values = fixedCost[i].props.value.split(';');
        for (let i = 0; i < displayIds.length; i++) {
          fixedCostItems[displayIds[i]] = values[i];
        }
      } else {
        fixedCostItems[fixedCost[i]['display_id']] = fixedCost[i].props.value;
      }
    }
    fixedCostItems['period'] = this.period;
    fixedCostItems['construction_no'] = constructionNum;
    if (this.radioData === 0) {
      delete fixedCostItems.billing_month;
    }
  }

  private read(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    return file;
  }
}
